import announcementsReducer from "./reducers";
export { default as announcementsTypes } from "./types";
export { default as announcementsOperations } from "./operations";
export default announcementsReducer;
